export default __webpack_public_path__ + "static/media/mechanic2.7ad2e929.jpeg";